import { Model } from "pinia-orm";
import { Question, Answer, QuestionnaireSession } from "@/models";

export default class QuestionnaireSessionQuestion extends Model {
  static entity = "questionnaireSessionQuestions";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      order: this.number(null),

      // Foreign Keys
      questionUuid: this.string(""),
      questionData: this.belongsTo(Question, "questionUuid"),
      questionnaireSession: this.string(""),
      questionnaireSessionData: this.belongsTo(QuestionnaireSession, "questionnaireSession"),
      answer: this.hasOne(Answer, "questionnaireSessionQuestionUuid"),
      isDisplayed: this.boolean(true),
    };
  }
}
